import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let ThervoIcon = (props) => (
	<SvgIcon {...props} viewBox={"0 0 32 32"}>
		<title>Thervo</title>
		<g fillRule="evenodd">
			<use xlinkHref="#B" fill="#e53a6e" />
			<path
				d="M30.93-26.84c1.79 3.11 1.27 6.91-1.04 9.42a9.97 9.97 0 0 0-1.21-3.79h0l-1.49-2.63c-.01-.03-.03-.07-.05-.09l-.14-.25-3.82-6.62c3.03-.31 6.12 1.14 7.75 3.96h0z"
				fill="#7866a4"
			/>
			<path
				d="M27-12.37c-1.79 3.11-5.35 4.55-8.68 3.81A10.04 10.04 0 0 0 21-11.5h0l1.53-2.61.06-.09.14-.24 3.82-6.62c1.8 2.48 2.08 5.88.45 8.69h0z"
				fill="#3f95c4"
			/>
			<path
				d="M12.5-8.53c-3.59 0-6.62-2.36-7.64-5.61 1.22.54 2.55.83 3.89.85h0l3.03.02h.11.28 7.64c-1.25 2.8-4.05 4.74-7.31 4.74h0z"
				fill="#65b5b2"
			/>
			<path
				d="M1.93-19.16C.14-22.27.66-26.07 2.97-28.58a9.8 9.8 0 0 0 1.21 3.79h0l1.5 2.63c.01.03.03.07.05.09l.14.25 3.82 6.62c-3.04.31-6.13-1.14-7.76-3.96h0z"
				fill="#f19c59"
			/>
			<path
				d="M5.86-33.63c1.79-3.11 5.35-4.55 8.68-3.81-2.07 1.52-3.16 3.72-4.41 5.89L6.3-24.94c-1.79-2.48-2.07-5.88-.44-8.69h0z"
				fill="#f0625e"
			/>
		</g>
		<path
			d="M41.72-25.79H38.7v-1.97h3.03v-5.1h2.18v5.1h4.15v1.97H43.9v10.24c0 1 .24 1.74.71 2.22.45.51 1 .76 1.63.76a4.3 4.3 0 0 0 .87-.08c.24-.06.5-.15.8-.29l.68 1.87a5.36 5.36 0 0 1-1.17.39 7.27 7.27 0 0 1-1.41.12c-1.18 0-2.18-.38-2.99-1.14-.41-.39-.73-.87-.95-1.44-.23-.56-.34-1.25-.34-2.06v-10.59zm9.79-9.65h2.18v8.23l-.14 2.65h.14c.52-1.09 1.29-1.98 2.31-2.69 1.02-.7 2.24-1.05 3.67-1.05 1.04 0 1.95.17 2.72.51a5.27 5.27 0 0 1 1.92 1.41c.51.6.88 1.32 1.12 2.14.24.83.36 1.73.36 2.7v10.44h-2.18v-10.06c0-1.75-.4-3.04-1.19-3.89s-1.88-1.28-3.26-1.28c-.79 0-1.52.18-2.18.54s-1.24.84-1.73 1.43a6.73 6.73 0 0 0-1.16 2.07c-.27.79-.41 1.61-.41 2.45v8.74H51.5v-24.34zm32.78 20.4c-.29.61-.67 1.19-1.12 1.73a7.72 7.72 0 0 1-1.58 1.43c-.6.41-1.29.73-2.06.97s-1.62.36-2.55.36c-1.2 0-2.31-.22-3.33-.66a7.69 7.69 0 0 1-2.63-1.85c-.74-.79-1.31-1.73-1.72-2.81s-.61-2.26-.61-3.55a10.48 10.48 0 0 1 .56-3.42c.37-1.08.91-2.02 1.61-2.82s1.55-1.44 2.55-1.92 2.12-.71 3.37-.71c1.2 0 2.28.21 3.25.63.96.42 1.79 1.01 2.47 1.77s1.21 1.67 1.58 2.74.56 2.24.56 3.54v.2a.61.61 0 0 0-.03.17v.2h-13.7c.02 1.16.23 2.14.61 2.96s.87 1.49 1.46 2.02 1.25.92 1.97 1.17c.73.25 1.43.37 2.11.37 1.41 0 2.52-.32 3.33-.97.82-.65 1.5-1.47 2.04-2.46l1.86.91zm-1.94-5.85c-.02-.54-.14-1.13-.34-1.77a5.53 5.53 0 0 0-.95-1.77c-.43-.55-1-1-1.72-1.36-.71-.36-1.59-.54-2.63-.54a5.5 5.5 0 0 0-1.97.36c-.63.24-1.21.58-1.72 1.04-.51.45-.94 1.02-1.29 1.7s-.58 1.46-.7 2.35h11.32zm5.31 9.79v-16.66h2.04v2.92h.14c.16-.5.41-.96.76-1.38s.75-.78 1.19-1.09a6.17 6.17 0 0 1 1.39-.73c.48-.18.96-.27 1.41-.27.52 0 .95.04 1.29.12a3.78 3.78 0 0 1 .99.39l-.68 1.97c-.45-.23-1.08-.34-1.87-.34a3.55 3.55 0 0 0-1.7.43c-.54.28-1.02.68-1.43 1.18s-.74 1.1-.99 1.79c-.25.7-.37 1.45-.37 2.27v9.39h-2.17zm11.22-16.66h2.31l5.68 14.21h.07l5.71-14.21h2.28l-6.87 16.66h-2.38l-6.8-16.66zm25.09-.54c1.22 0 2.35.23 3.38.68s1.92 1.08 2.67 1.87 1.33 1.73 1.75 2.81.63 2.25.63 3.52-.21 2.44-.63 3.52-1 2.01-1.75 2.8-1.64 1.42-2.67 1.87-2.16.68-3.38.68a8.29 8.29 0 0 1-3.35-.68c-1.03-.45-1.92-1.08-2.67-1.87s-1.33-1.73-1.75-2.8c-.42-1.08-.63-2.25-.63-3.52s.21-2.44.63-3.52a8.61 8.61 0 0 1 1.75-2.81c.75-.79 1.64-1.42 2.67-1.87 1.03-.46 2.14-.68 3.35-.68zm0 15.77c.82 0 1.6-.16 2.35-.49a6.22 6.22 0 0 0 1.99-1.39c.58-.6 1.04-1.33 1.39-2.18s.53-1.8.53-2.84-.18-1.99-.53-2.84a7.02 7.02 0 0 0-1.39-2.18c-.57-.6-1.24-1.07-1.99-1.39-.75-.33-1.53-.49-2.35-.49s-1.6.17-2.35.49a6.22 6.22 0 0 0-1.99 1.39c-.58.6-1.04 1.33-1.38 2.18s-.51 1.8-.51 2.84.17 1.99.51 2.84.8 1.58 1.38 2.18 1.24 1.07 1.99 1.39c.75.33 1.53.49 2.35.49z"
			fill="#222"
			stroke="#222"
			strokeWidth="1.3"
			strokeMiterlimit="10"
		/>
		<g fillRule="evenodd">
			<use xlinkHref="#B" x="-0.43" y="39" fill="#e53a6e" />
			<path
				d="M30.5 12.16c1.79 3.11 1.27 6.91-1.04 9.42a9.97 9.97 0 0 0-1.21-3.79h0l-1.49-2.63c-.01-.03-.03-.07-.05-.09l-.14-.25-3.83-6.62c3.04-.31 6.13 1.14 7.76 3.96h0z"
				fill="#7866a4"
			/>
			<path
				d="M26.57 26.63c-1.79 3.11-5.35 4.55-8.68 3.81a10.04 10.04 0 0 0 2.68-2.94h0l1.53-2.61.06-.09.14-.24 3.82-6.62c1.8 2.48 2.08 5.88.45 8.69h0z"
				fill="#3f95c4"
			/>
			<path
				d="M12.08 30.47c-3.59 0-6.62-2.36-7.64-5.61 1.22.54 2.55.83 3.89.85h0l3.03.02h.11.28 7.64c-1.26 2.8-4.06 4.74-7.31 4.74h0z"
				fill="#65b5b2"
			/>
			<path
				d="M1.5 19.84c-1.79-3.11-1.27-6.91 1.04-9.42a9.8 9.8 0 0 0 1.21 3.79h0l1.5 2.63c.01.03.03.07.05.09l.14.25 3.82 6.62c-3.04.31-6.13-1.14-7.76-3.96h0z"
				fill="#f19c59"
			/>
			<path
				d="M5.43 5.37c1.79-3.11 5.35-4.55 8.68-3.81-2.07 1.52-3.16 3.72-4.41 5.89l-3.82 6.62c-1.8-2.49-2.08-5.89-.45-8.7h0z"
				fill="#f0625e"
			/>
		</g>
		<defs>
			<path
				id="B"
				d="M20.35-37.47c3.59 0 6.62 2.36 7.64 5.61-1.22-.54-2.55-.83-3.89-.85h0l-3.03-.02h-.1-.28-7.64a7.98 7.98 0 0 1 7.3-4.74h0z"
			/>
		</defs>
	</SvgIcon>
);

ThervoIcon = memo(ThervoIcon);
ThervoIcon.displayName = "ThervoIcon";
ThervoIcon.muiName = "ThervoIcon";

export default ThervoIcon;
